export class Hotel 
{

	search (parent)
	{
		let text = $(parent).val();

		if (!text)
		{
			$('.settings-search__list li').show();
			return ;
		}

		$('.settings-search__list li').each(function(){
			let name = $(this).find('.settings-search__item-label span').text();
			if (name.match(new RegExp(text, 'gi')))
			{
				$(this).show();
			}
			else
			{
				$(this).hide();
			}
		});
	}

	setHotel(parent)
	{
		let hotelName = $(parent).closest('li').find('span')[0].childNodes[0].nodeValue;
		let input = $('.hotels__settings-search .hotels__settings-search-input');
		input.val(hotelName);

		if (input.attr('type') == 'search')
		{
			this.loadItems();
		}
		else
		{
			location.href = '/hotels/' + $(parent).val() + '/?tab=rooms#hotel-common';
		}
	}

	applyFilter(parent)
	{
		let el = $(parent);
		if (el.prop('checked'))
		{
			if (el.val() == '' || el.attr('type') == 'radio')
			{
				this.removeAllChoiced(el.attr('name').replace('[]', ''));
			}
			
			if (el.val() != '')
			{
				let title = el.val();
				if (parseInt(title) == title)
					title = el.closest('.filters__choice-item').find('.form__check-caption').text();
				console.log(title);
				this.addChoiced(el.attr('name').replace('[]', ''), el.val(), title);
			}
		}
		else
		{
			this.removeChoiced(el.attr('name').replace('[]', ''), el.val());
		}

		this.loadItems(parent.form);
	}

	loadItems (parent = null)
	{
		let _this = this;
		let data;

		if (this.currAjax) {
			this.currAjax.abort();
		}

		if (!parent)
		{
			parent = $('.hotel__filters form')[0];
		}

		console.log(parent);

		if ($(parent).attr('data-filtertype') == 'addition')
		{
			data = $(parent).add($('.filters__form')).serialize();
		}
		else
		{
			data = $(parent).serialize();
			$('#filter_letter_0').prop('checked', 1);
		}

		let hotelId = $('.hotels__settings-search .settings-search__list .settings-search__item-input:checked').val();
		if (hotelId)
		{
			data += '&hotelId=' + hotelId;
		}

		data += '&action=loadItems';

		$('.hotels__loader').addClass('active');

		this.currAjax = $.ajax({
			url: "/ajax.php?mid=3",
			type: 'POST',
			data: data,
			dataType: "html",
			success: function(html){
				if ($(parent).find('input[type=hidden][name=mode]').val() == 'list')
				{
					let table = $('.hotels__table-container').replaceWith($(html).find('.hotels__table-container'));
				}
				else if ($(parent).find('input[type=hidden][name=mode]').val() == 'rooms')
				{
					let table = $('.hotel-rooms__table').replaceWith(html);
				}
				else
				{
					let table = $('.hotels__list-wrapper').replaceWith(html);
				}
				_this.applyEvents();
				$('.hotels__loader').removeClass('active');
				
				_this.currAjax = null;
			},
			error: function(err){
				if (err.statusText === "abort") {
					// Запрос был прерван, можно просто проигнорировать
					console.warn('Запрос был прерван.');
				} else {
					// Обработка остальных ошибок
					alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
				}
				$('.hotels__loader').removeClass('active');
				
				_this.currAjax = null;
			}
		});
	}

	loadPlacesHotels (parent = null)
	{
		let _this = this;
		let text = $(parent).val();

		$.ajax({
			url: "/ajax.php?mid=3",
			type: 'POST',
			data: {
				action: 'loadPlacesHotels',
				text: text
			},
			dataType: "html",
			success: function(html){
				
			},
			error: function(err){
				if (err.statusText === "abort") {
			// Запрос был прерван, можно просто проигнорировать
			console.warn('Запрос был прерван.');
		} else {
			// Обработка остальных ошибок
			alert('Ошибка! Попробуйте повторить запрос. Error: ' + err.statusText);
		}
			}
		});
	}

	goToHotel(parent)
	{
		let id = $(parent).find('.hotels__settings-search .settings-search__item-input:checked').val();
		let url = '/hotels/' + id + '/?tab=rooms#hotel-common';

		location.href = url;
	}

	addChoiced(name, value, title = '')
	{
		if (!title)
			title = value;
		let ul = $('.filters-choiced__list');
		ul.append('<li class="filters-choiced__item"><button class="btn btn--s filters-choiced__item-btn" type="button" data-filter="' + name + '" value="' + value + '" onclick="hotel.deleteChoiced(this);"><span>' + title + '</span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M17.7208 6.27916C17.542 6.10042 17.2996 6 17.0467 6C16.7939 6 16.5514 6.10042 16.3726 6.27916L12 10.6518L7.62737 6.27916C7.44857 6.10042 7.2061 6 6.95327 6C6.70044 6 6.45797 6.10042 6.27916 6.27916C6.10042 6.45797 6 6.70044 6 6.95327C6 7.2061 6.10042 7.44857 6.27916 7.62737L10.6518 12L6.27916 16.3726C6.10042 16.5514 6 16.7939 6 17.0467C6 17.2996 6.10042 17.542 6.27916 17.7208C6.45797 17.8996 6.70044 18 6.95327 18C7.2061 18 7.44857 17.8996 7.62737 17.7208L12 13.3482L16.3726 17.7208C16.5514 17.8996 16.7939 18 17.0467 18C17.2996 18 17.542 17.8996 17.7208 17.7208C17.8996 17.542 18 17.2996 18 17.0467C18 16.7939 17.8996 16.5514 17.7208 16.3726L13.3482 12L17.7208 7.62737C17.8996 7.44857 18 7.2061 18 6.95327C18 6.70044 17.8996 6.45797 17.7208 6.27916V6.27916Z" fill="#374957"></path></svg></button></li>');
	}

	removeChoiced(name, value)
	{
		console.log(name);
		console.log(value);
		$('.filters-choiced__list li.filters-choiced__item button[data-filter="' + name + '"][value="' + value + '"]').closest('li').remove();
	}

	removeAllChoiced(name)
	{
		console.log(name);
		$('.filters-choiced__list li.filters-choiced__item button[data-filter="' + name + '"]').closest('li').remove();
	}

	deleteChoiced(parent)
	{
		let el = $(parent);
		let name = el.attr('data-filter');
		let value = el.val();
		$('.filters__choice-list[data-filter="' + name + '"] input[value="' + value + '"]').prop('checked', 0).trigger('change');
	}

	applyEvents(block = null)
	{
		let _this = this;

		// Swiper
		$('.hotel-card').each(function () {
			let hotelCardThumbs = new Swiper($(this).find(".hotel-card-thumbs")[0], {
				spaceBetween: 8,
				slidesPerView: 5,
				watchSlidesProgress: true,
			});
			let hotelCardSlider = new Swiper($(this).find(".hotel-card-slider")[0], {
				modules: [Thumbs, EffectFade],
				spaceBetween: 8,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				thumbs: {
					swiper: hotelCardThumbs,
					autoScrollOffset: 1,
				},
			});
		});

		$(".hotel-card__link").on("click", function (e) {
			var callbackPopup = $(".hotel-card-thumbs__item");
			if (callbackPopup.is(e.target) || callbackPopup.has(e.target).length !== 0) {
				e.preventDefault();
			};
		});

		const hotelFirst = document.querySelector('.hotel-first')
		if (hotelFirst) {
			let hotelFirstThumbs = new Swiper(".hotel-first-thumbs", {
				spaceBetween: 8,
				slidesPerView: "auto",
				watchSlidesProgress: true,
				breakpoints: {
					768: {
						spaceBetween: 12,
					},
					1224: {
						spaceBetween: 16,
					},
				}
			});
			let hotelFirstSlider = new Swiper(".hotel-first-slider", {
				modules: [Thumbs, EffectFade],
				spaceBetween: 8,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				thumbs: {
					swiper: hotelFirstThumbs,
					autoScrollOffset: 1,
				},
			});
		}

		$('.room-card').each(function () {
			let roomCardThumbs = new Swiper($(this).find(".room-card-thumbs")[0], {
				spaceBetween: 8,
				slidesPerView: 5,
				watchSlidesProgress: true,
			});
			let roomCardSlider = new Swiper($(this).find(".room-card-slider")[0], {
				modules: [Thumbs, EffectFade],
				spaceBetween: 8,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				thumbs: {
					swiper: roomCardThumbs,
					autoScrollOffset: 1,
				},
			});
		});

		const popupGallery = document.querySelector('.popup-gallery');
		const popupGallerySliderList = document.querySelector('.popup-gallery-slider__list');
		const popupGalleryThumbsList = document.querySelector('.popup-gallery-thumbs__list');
		let popupGalleryThumbs = null;
		let popupGallerySlider = null;

		
		$(".room-card-slider__item-container").on("click", function (e) {
			e.preventDefault();

			let roomCardImagesSrcArr = $(this).closest(".room-card-slider").find(".room-card-slider__item-image").map(function () {
				return $(this).attr("src");
			}).toArray();
			let roomCardImagesSrcsetArr = $(this).closest(".room-card-slider").find(".room-card-slider__item-image").map(function () {
				return $(this).attr("srcset");
			}).toArray();

			let roomCardImagesSrcArrBig = roomCardImagesSrcArr.map(function (item) {
				return item.replaceAll("small_", "");
			});
			let roomCardImagesSrcsetArrBig = roomCardImagesSrcsetArr.map(function (item) {
				return item.replaceAll("small_", "");
			});

			let indexOfClickedCard = $(this).closest(".room-card-slider__item").index();

			$("body").addClass("no-scroll");
			$(".popup-gallery").addClass("active");

			popupGallerySliderList.innerHTML = roomCardImagesSrcArrBig.map(function (roomCardImageSrcBig, i) {
				return '<li class="popup-gallery-slider__item swiper-slide"><img class="popup-gallery-slider__item-image" src="' + roomCardImageSrcBig + '" srcset="' + roomCardImagesSrcsetArrBig[i] + '"></li>';
			}).join('');
			popupGalleryThumbsList.innerHTML = roomCardImagesSrcArr.map(function (roomCardImageSrc, i) {
				return '<li class="popup-gallery-thumbs__item swiper-slide"><div class="popup-gallery-thumbs__item-container"><img class="popup-gallery-thumbs__item-image" src="' + roomCardImageSrc + '" srcset="' + roomCardImagesSrcsetArr[i] + '"></div></li>';
			}).join('');

			popupGalleryThumbs = new Swiper(".popup-gallery-thumbs", {
				initialSlide: indexOfClickedCard,
				spaceBetween: 8,
				slidesPerView: "auto",
				watchSlidesProgress: true,
			});
			popupGallerySlider = new Swiper(".popup-gallery-slider", {
				initialSlide: indexOfClickedCard,
				modules: [Thumbs, EffectFade],
				spaceBetween: 8,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				thumbs: {
					swiper: popupGalleryThumbs,
					autoScrollOffset: 1,
				},
			});
		});


		$(".popup__close, .popup__cancel").on("click", function (e) {
		// popup gallery
			if ($(this).closest(".popup").hasClass("popup-gallery")) {
				popupGalleryThumbs.destroy(true, true);
				popupGallerySlider.destroy(true, true);
				popupGallerySliderList.innerHTML = "";
				popupGalleryThumbsList.innerHTML = "";
			}
		});

		$(".popup").on("click", function (e) {
			var callbackPopup = $(".popup__card")
			if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
				$(this).removeClass("active");
				$("body").removeClass("no-scroll");

		// popup gallery
				if ($(this).hasClass("popup-gallery")) {
					popupGalleryThumbs.destroy(true, true);
					popupGallerySlider.destroy(true, true);
					popupGallerySliderList.innerHTML = "";
					popupGalleryThumbsList.innerHTML = "";
				}
			};
		});

		document.addEventListener("keypress", function onEvent(e) {
			if (e.key === "Escape") {
				if ($(".popup").hasClass("active")) {
					e.preventDefault();
		// popup gallery
					if ($(".popup-gallery").hasClass("active")) {
						popupGalleryThumbs.destroy(true, true);
						popupGallerySlider.destroy(true, true);
						popupGallerySliderList.innerHTML = "";
						popupGalleryThumbsList.innerHTML = "";
					}

					$(".popup").removeClass("active");
					$("body").removeClass("no-scroll");
				}
			}
		});
	}
}